export const attachCurrentQueryParams = (link: string | undefined) => {
  if (!link) return link;
  if (typeof window === 'undefined') return link;

  const currentUrl = new URL(window.location.href);

  // Resolve relative link against the current origin
  const linkUrl = new URL(link, currentUrl.origin);

  // Append the current query parameters to the link's parameters
  currentUrl.searchParams.forEach((value, key) => {
    // Using Set to overwrite any duplicates
    linkUrl.searchParams.set(key, value);
  });

  return linkUrl.toString();
};
